<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import bootstrapPlugin from '@fullcalendar/bootstrap'
import listPlugin from '@fullcalendar/list'
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import { getFirestore, collection, getDocs } from 'firebase/firestore/lite'
import CryptoJS from 'crypto-js'

import { firebase } from '../../../../../firebase-int'
import moment from 'moment'

import '@fullcalendar/core/main.css'
import '@fullcalendar/daygrid/main.css'
import '@fullcalendar/timegrid/main.css'
import '@fullcalendar/list/main.css'
import '@fullcalendar/bootstrap/main.css'

const firestore = getFirestore(firebase)

export default {
  page: {
    title: 'Event',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { FullCalendar, Layout, PageHeader },
  data() {
    return {
      title: 'Event',
      items: [
        {
          text: 'Gebi',
          href: '/',
        },
        {
          text: 'Event',
          active: true,
        },
      ],
      calendarWeekends: true,
      calendarPlugins: [
        dayGridPlugin,
        timeGridPlugin,
        interactionPlugin,
        bootstrapPlugin,
        listPlugin,
      ],
      themeSystem: 'bootstrap',
      calendarEvents: null,
      createModal: false,
      showmodal: false,
      eventModal: false,
      submitted: false,
      submit: false,
      newEventData: {},
      edit: {},
      deleteId: {},
      event: {
        title: '',
        category: '',
      },
      editevent: {
        editTitle: '',
      },

      loading: true,
      noOfMembers: 0,

      pvtData: '',
      secret: '123#$%',
      encData: '',

      tableData: [],

      currentEvent: null,
    }
  },
  validations: {
    event: {
      title: { required },
      category: { required },
    },
  },
  methods: {
    /**
     * Modal open for edit event
     */
    showEventDetails(info) {
      this.event = info.event
      //console.log('>>>>>>>>>>>> Event Details: '+JSON.stringify(this.calendarEvents))
      for (let i = 0; i < this.calendarEvents.length; i++) {
        if (this.calendarEvents[i].id == this.event.id) {
          this.currentEvent = this.calendarEvents[i]
          break
        }
      }
      this.eventModal = true
    },
    /**
     * Closes the modal
     */
    closeModal() {
      this.eventModal = false
    },

    async readEvents() {
      let industriesData = []
      var event = null
      const industriesCol = collection(firestore, 'event')
      const industriesSnapshot = await getDocs(industriesCol)
      industriesSnapshot.forEach((doc) => {
        event = doc.data()
        event.id = doc.id
        event.created = doc
          .data()
          .created.toDate()
          .toLocaleDateString(undefined, this.dateOptions)
        event.updated = doc
          .data()
          .updated.toDate()
          .toLocaleDateString(undefined, this.dateOptions)
        event.start = new Date(moment(doc.data().fromDate, 'DD/MM/YYYY h:mm a'))
        event.end = new Date(moment(doc.data().toDate, 'DD/MM/YYYY h:mm a'))

        if (doc.data().color) {
          event.className = doc.data().color
        } else event.className = 'bg-soft-success text-dark'

        industriesData.push(event)
        // console.log(doc.id, " => ", doc.data());
      })
      this.noOfMembers = industriesData.length
      this.loading = false
      return industriesData
    },
  },
  async mounted() {
    this.calendarEvents = await this.readEvents()
    this.currentEvent = this.calendarEvents[0]
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <!--div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<div class="row align-items-center">
							<div class="col-xl-2 col-lg-3 col-6">
								<img
									src="@assets/images/cal.png"
									class="mr-4 align-self-center img-fluid"
									alt="cal"
								/>
							</div>
							<div class="col-xl-10 col-lg-9">
								<div class="mt-4 mt-lg-0">
									<h5 class="mt-0 mb-1 font-weight-bold"
										>Welcome to Your Calendar</h5
									>
									<p class="text-muted mb-2">
										The calendar shows the events synced from all your linked
										calendars. Click on event to see or edit the details. You
										can create new event by clicking on "Create New event"
										button or any cell available in calendar below.
									</p>

									<button
										id="btn-new-event"
										class="btn btn-primary mt-2 mr-1"
										@click="showmodal = true"
									>
										<i class="uil-plus-circle"></i> Create New Event
									</button>
									<button class="btn btn-white mt-2">
										<i class="uil-sync"></i> Link Calendars
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div-->

    <div v-if="loading" class="row">
      <div class="col-lg-12 col-sm-12 col-md-12">
        <p class="text-muted font-13 mb-4"></p>
        <p class="text-muted font-13 mb-4">Loading ...</p>
        <b-spinner label="Loading..." variant="primary"></b-spinner>
      </div>
    </div>

    <div v-else class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="app-calendar">
              <FullCalendar
                ref="fullCalendar"
                default-view="dayGridMonth"
                :header="{
                  left: 'prev,next today',
                  center: 'title',
                  right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
                }"
                :button-text="{
                  today: 'Today',
                  month: 'Month',
                  week: 'Week',
                  day: 'Day',
                  list: 'List',
                  prev: 'Prev',
                  next: 'Next',
                }"
                :bootstrap-font-awesome="false"
                :editable="false"
                :droppable="false"
                :plugins="calendarPlugins"
                :events="calendarEvents"
                :weekends="calendarWeekends"
                :theme-system="themeSystem"
                @eventClick="showEventDetails"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-if="currentEvent"
      v-model="eventModal"
      title="Event Details"
      title-class="text-black font-18"
      hide-footer
    >
      <form>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="name"><i class="uil-package"></i> Title</label>
              <div>
                <input
                  id="name"
                  v-model="currentEvent.title"
                  type="text"
                  class="form-control"
                  readonly
                />
              </div>
              <!--div>
               {{ currentEvent.title }}
              </div-->
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="name"><i class="uil-subject"></i> Description</label>
              <div>
                <textarea
                  id="name"
                  v-model="currentEvent.description"
                  type="text"
                  class="form-control"
                  readonly
                  rows="6"
                />
              </div>
              <!--div>
                {{ currentEvent.description }}
              </div-->
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="name"><i class="uil-archway"></i> Venue</label>
              <div>
                <input
                  id="name"
                  v-model="currentEvent.venue"
                  type="text"
                  class="form-control"
                  readonly
                />
              </div>
              <!--div>
                {{ currentEvent.venue }}
              </div-->
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label for="name"><i class="uil-calender"></i> Date</label>
              <div>
                <input
                  id="name"
                  v-model="currentEvent.date"
                  type="text"
                  class="form-control"
                  readonly
                />
              </div>
              <!--div>
                {{ currentEvent.date }}
              </div-->
            </div>
          </div>

          <div v-if="currentEvent.organizedBy" class="col-12">
            <div class="form-group">
              <label for="name"
                ><i class="uil-user-square"></i> Organizer</label
              >
              <div>
                <input
                  id="name"
                  v-model="currentEvent.organizedBy"
                  type="text"
                  class="form-control"
                  readonly
                />
              </div>
              <!--div>
                {{ currentEvent.organizedBy }}
              </div-->
            </div>
          </div>
        </div>

        <div class="text-right">
          <b-button class="ml-1" variant="light" @click="closeModal"
            >Close</b-button
          >
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<style>
.fc-today {
  background: #dde1fe !important;
  border: none !important;
  border-top: 1px solid #ddd !important;

  color: #000;
}
.fc-event {
  cursor: pointer !important;
}
.fc-center h2 {
    font-size: 1.0em;
}
.fc-toolbar .btn {
font-size: 0.8em;
}
</style>
